var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistThinSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36,64a4.0002,4.0002,0,0,1,4-4H216a4,4,0,0,1,0,8H40A4.0002,4.0002,0,0,1,36,64Zm4,68H160a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8Zm72,56H40a4,4,0,0,0,0,8h72a4,4,0,0,0,0-8Zm131.83105-62.85059a3.99991,3.99991,0,0,1-4.98046,2.68213L204,117.376V192a28.045,28.045,0,1,1-8-19.56934V112a4.00053,4.00053,0,0,1,5.14941-3.83154l40,12A4,4,0,0,1,243.83105,125.14941ZM196,192a20,20,0,1,0-20,20A20.0226,20.0226,0,0,0,196,192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistThinSvgrepoCom);
export default __webpack_public_path__ + "static/media/playlist-thin-svgrepo-com.7bbcea085da1f881d506e2fcf17bd670.svg";
export { ForwardRef as ReactComponent };